export default __webpack_public_path__ + "locales/hy-AM/Ldap.json?hash=9fd6bb8ed268f22d2a3005a4c5d4138d";